import { Container, Title, Divider, Text, Card, Stack, Group, Button, Select, TextInput } from "@mantine/core";
import { RTEditor } from "../components/rt.editor";
import { useState } from "react";
import { useAuthHook } from "../hooks/auth.hooks";
// import {} from '@mantine/hooks';

export default function SupportPage() {
    const { injectHeader } = useAuthHook();
    const [selectedTopic, setSelectedTopic] = useState<'Feature Request' | 'Bug Report' | 'Question' | 'Other' | ''>('');
    const [emailFrom, setEmailFrom] = useState('');
    const [emailContent, setEmailContent] = useState('');

    const handleSubmit = async () => {
        console.log(selectedTopic, emailFrom, emailContent);
        const content = `<p>From: ${emailFrom}</p><p>Topic: ${selectedTopic}</p><br/><br/><p>Content: ${emailContent}</p>`;
        const req = new Request('/api/auth/feedback', {
            method: 'POST',
            body: JSON.stringify({ topic: selectedTopic, content: content }),
            headers: {
                'Content-Type': 'application/json'
            }
        });
        injectHeader(req);
        const res = await fetch(req);
        if(res.ok){
            console.log('Feedback submitted successfully');
            setEmailFrom('');
            setSelectedTopic('');
            setEmailContent('');
            // TODO: implement a toast
        }
    }

    return (
        <Container fluid>
            <Title>Support</Title>
            <Text size="lg" c="dimmed" mb="xl">Problems? Questions? Feature requests? We're here to help!</Text>

            <Card shadow="sm" p="lg" radius="md" withBorder mb="xl">
                <Stack>
                    <Group grow>
                        <Select
                            label="Topic"
                            placeholder="Select a topic"
                            data={['Feature Request', 'Bug Report', 'Question', 'Other']}
                            value={selectedTopic}
                            onChange={(value) => setSelectedTopic(value as 'Feature Request' | 'Bug Report' | 'Question' | 'Other')}
                        />
                        <TextInput
                            label="Email"
                            description="Where do you want the response sent?"
                            value={emailFrom}
                            type="email"
                            onChange={(e) => setEmailFrom(e.target.value)}
                        />
                    </Group>
                    <RTEditor
                        value={emailContent}
                        onChange={(value) => setEmailContent(value)}
                    />
                </Stack>
                <Divider my="md" />
                <Group justify="flex-end">
                    <Button onClick={handleSubmit} w="50%">Submit</Button>
                </Group>
            </Card>
        </Container>
    );
}
